import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/NavBar';
import { createClub } from '../services/api';
import { Plus, Trash2, Info } from 'lucide-react';
import { MapPin } from 'lucide-react';
import LocationAutocomplete from '../components/LocationAutocomplete';
import Footer from '../components/Footer';
import ClubPhotoUpload from '../components/ClubPhotoUpload';

function CreateClub() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom: '',
    ville: '',
    distance: '',
    niveau: '',
    description: '',
    imageClub: '',
    typePaces: 'inclusif',
    isPrivate: false  // ✨ NOUVEAU
  });

  const [pacesClub, setPacesClub] = useState({
    typeSeance: '',
    paceMinMinutes: '',
    paceMinSecondes: '',
    paceMaxMinutes: '',
    paceMaxSecondes: ''
  });

  const [locationData, setLocationData] = useState(null);
  const [seances, setSeances] = useState([]);

  const handlePhotoUpdate = (photoUrl) => {
  setFormData({
    ...formData,
    imageClub: photoUrl
  });
};

  const handleSubmit = async () => {
  if (!formData.nom || !formData.ville || !formData.distance || 
      !formData.niveau || !formData.description) {
    alert('Veuillez remplir tous les champs obligatoires');
    return;
  }

  if (!locationData) {
    alert('Veuillez sélectionner une ville valide dans les suggestions');
    return;
  }
  
  // Si type pace spécifique, valider les paces
  if (formData.typePaces === 'specifique') {
    if (!pacesClub.typeSeance || !pacesClub.paceMinMinutes || !pacesClub.paceMaxMinutes) {
      alert('Veuillez remplir les paces du club');
      return;
    }
  }

  try {
    // UN SEUL objet clubData avec TOUTES les données
    const clubData = {
      ...formData,
      seances: seances,
      location: {
        type: 'Point',
        coordinates: [locationData.longitude, locationData.latitude]
      }
    };

    // Ajouter les paces si spécifique
    if (formData.typePaces === 'specifique') {
      const paceMinTotal = parseInt(pacesClub.paceMinMinutes) * 60 + parseInt(pacesClub.paceMinSecondes || 0);
      const paceMaxTotal = parseInt(pacesClub.paceMaxMinutes) * 60 + parseInt(pacesClub.paceMaxSecondes || 0);
      
      clubData.pacesClub = {
        typeSeance: pacesClub.typeSeance,
        paceMin: paceMinTotal,
        paceMax: paceMaxTotal
      };
    }

    await createClub(clubData);  // UN SEUL appel
    navigate('/');
  } catch (error) {
    console.error('Erreur lors de la création:', error);
    alert('Erreur lors de la création du club');
  }
};

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePacesChange = (e) => {
    setPacesClub({
      ...pacesClub,
      [e.target.name]: e.target.value
    });
  };

  const handleLocationSelect = (location) => {
    setLocationData(location);
    setFormData({
      ...formData,
      ville: location.name
    });
  };

  const ajouterSeance = () => {
    setSeances([...seances, {
      jour: 'Lundi',
      heure: '18:00',
      typeSeance: 'Endurance Fondamentale',
      paceMinMinutes: '',
      paceMinSecondes: '',
      paceMaxMinutes: '',
      paceMaxSecondes: '',
      distance: '',
      description: '',
      lieu: ''
    }]);
  };

  const supprimerSeance = (index) => {
    setSeances(seances.filter((_, i) => i !== index));
  };

  const modifierSeance = (index, field, value) => {
    const newSeances = [...seances];
    newSeances[index][field] = value;
    setSeances(newSeances);
  };

  const formatPace = (minutes, secondes) => {
    if (!minutes) return '--:--';
    return `${minutes}:${(secondes || '00').toString().padStart(2, '0')}`;
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-slate-900 rounded-xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-white mb-6">Créer un nouveau groupe</h2>

          <div className="space-y-6">
            {/* Informations de base */}
            <div>
              <label className="block text-white font-semibold mb-2">Nom du groupe *</label>
              <input
                type="text"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-slate-700"
                placeholder="Ex: Coureurs du Dimanche"
              />
            </div>

            <div className="mb-6">
              <label className="block text-white font-medium mb-2">
                Image du club
              </label>
              <ClubPhotoUpload
                currentPhoto={formData.imageClub}
                onPhotoUpdate={handlePhotoUpdate}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <LocationAutocomplete
              value={formData.ville}
              onChange={(ville) => setFormData({ ...formData, ville })}
              onLocationSelect={handleLocationSelect}
              required={true}
              />

              <div>
                <label className="block text-white font-semibold mb-2">Distance typique *</label>
                <select
                  name="distance"
                  value={formData.distance}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-gray-400 focus:border-transparent bg-slate-700"
                >
                  <option value="">Sélectionner...</option>
                  <option value="3-5 km">3-5 km</option>
                  <option value="5-10 km" className=''>5-10 km</option>
                  <option value="10+ km">10+ km</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-white font-semibold mb-2">Niveau *</label>
                <select
                  name="niveau"
                  value={formData.niveau}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border text-gray-400 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-slate-700"
                >
                  <option value="">Sélectionner...</option>
                  <option value="Débutant">Débutant</option>
                  <option value="Intermédiaire">Intermédiaire</option>
                  <option value="Avancé">Avancé</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">Description *</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-slate-700"
                rows="3"
                placeholder="Décrivez l'ambiance et les objectifs de votre groupe..."
              />
            </div>

            {/* ============================================ */}
            {/* SECTION VISIBILITÉ DU CLUB */}
            {/* ============================================ */}
            <div className="bg-slate-800 rounded-xl shadow-lg p-6 mb-6">
              <h2 className="text-xl font-semibold text-white mb-4">
                🔒 Visibilité du club
              </h2>
              
              <div className="space-y-4">
                {/* Club Public */}
                <label className="flex items-start space-x-3 p-4 border-2 rounded-lg cursor-pointer hover:bg-slate-700 transition">
                  <input
                    type="radio"
                    name="isPrivate"
                    value="false"
                    checked={!formData.isPrivate}
                    onChange={(e) => setFormData({ ...formData, isPrivate: false })}
                    className="mt-1"
                  />
                  <div>
                    <div className="font-semibold text-white flex items-center">
                      <span className="mr-2">🌍</span>
                      Club Public
                    </div>
                    <p className="text-sm text-gray-400 mt-1">
                      N'importe qui peut voir et rejoindre ce club
                    </p>
                  </div>
                </label>

                {/* Club Privé */}
                <label className="flex items-start space-x-3 p-4 border-2 rounded-lg cursor-pointer hover:bg-slate-700 transition">
                  <input
                    type="radio"
                    name="isPrivate"
                    value="true"
                    checked={formData.isPrivate}
                    onChange={(e) => setFormData({ ...formData, isPrivate: true })}
                    className="mt-1"
                  />
                  <div>
                    <div className="font-semibold text-white flex items-center">
                      <span className="mr-2">🔒</span>
                      Club Privé
                    </div>
                    <p className="text-sm text-gray-400 mt-1">
                      Seuls les membres invités peuvent rejoindre ce club
                    </p>
                  </div>
                </label>
              </div>

              {formData.isPrivate && (
                <div className="mt-4 p-4 bg-slate-700 border border-blue-200 rounded-lg">
                  <div className="flex items-start space-x-2">
                    <Info size={20} className="text-white mt-0.5 flex-shrink-0" />
                    <div className="text-sm text-white">
                      <p className="font-medium mb-1">Comment fonctionne un club privé ?</p>
                      <ul className="list-disc list-inside space-y-1 text-gray-400">
                        <li>Vous devrez inviter les membres un par un</li>
                        <li>Les utilisateurs peuvent demander à rejoindre</li>
                        <li>Vous devrez approuver chaque demande</li>
                        <li>Le club n'apparaîtra pas dans les recherches publiques</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Type de club (pace) */}
            <div className="border-t pt-6">
              <h3 className="text-xl font-bold text-white mb-4">Type de club</h3>
              
              <div className="space-y-3">
                <label className="flex items-start space-x-3 p-4 border-2 rounded-lg cursor-pointer hover:bg-slate-700 transition">
                  <input
                    type="radio"
                    name="typePaces"
                    value="inclusif"
                    checked={formData.typePaces === 'inclusif'}
                    onChange={handleChange}
                    className="mt-1"
                  />
                  <div>
                    <p className="font-semibold text-white">Club inclusif</p>
                    <p className="text-sm text-gray-400">Accueille tous les niveaux, pas de pace spécifique requis</p>
                  </div>
                </label>

                <label className="flex items-start space-x-3 p-4 border-2 rounded-lg cursor-pointer hover:bg-slate-700 transition">
                  <input
                    type="radio"
                    name="typePaces"
                    value="specifique"
                    checked={formData.typePaces === 'specifique'}
                    onChange={handleChange}
                    className="mt-1"
                  />
                  <div>
                    <p className="font-semibold text-white">Club avec paces spécifiques</p>
                    <p className="text-sm text-gray-400">Défini des allures cibles pour les entraînements (±10 sec/km)</p>
                  </div>
                </label>
              </div>

              {/* Configuration paces spécifiques */}
              {formData.typePaces === 'specifique' && (
                <div className="mt-4 p-4 bg-indigo-50 rounded-lg space-y-4">
                  <div className="bg-blue-50 border-l-4 border-blue-500 p-3">
                    <div className="flex">
                      <Info className="text-blue-500 mr-2 flex-shrink-0" size={20} />
                      <p className="text-sm text-gray-700">
                        Définissez une plage d'allures pour votre club. Les coureurs dont les paces correspondent 
                        (±10 sec/km) pourront vous trouver facilement.
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2">Type de séance principal</label>
                    <select
                      name="typeSeance"
                      value={pacesClub.typeSeance}
                      onChange={handlePacesChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    >
                      <option value="">Sélectionner...</option>
                      <option value="Endurance Fondamentale">Endurance Fondamentale</option>
                      <option value="Récupération">Récupération</option>
                      <option value="Seuil/Tempo">Seuil/Tempo</option>
                      <option value="Fractionné Court">Fractionné Court</option>
                      <option value="Fractionné Long">Fractionné Long</option>
                      <option value="Sortie Longue">Sortie Longue</option>
                    </select>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-gray-700 font-semibold mb-2">Pace minimum</label>
                      <div className="flex space-x-2">
                        <input
                          type="number"
                          name="paceMinMinutes"
                          value={pacesClub.paceMinMinutes}
                          onChange={handlePacesChange}
                          min="3"
                          max="10"
                          placeholder="Min"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        />
                        <span className="self-center">:</span>
                        <input
                          type="number"
                          name="paceMinSecondes"
                          value={pacesClub.paceMinSecondes}
                          onChange={handlePacesChange}
                          min="0"
                          max="59"
                          placeholder="Sec"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        />
                        <span className="self-center text-gray-600">/km</span>
                      </div>
                    </div>

                    <div>
                      <label className="block text-gray-700 font-semibold mb-2">Pace maximum</label>
                      <div className="flex space-x-2">
                        <input
                          type="number"
                          name="paceMaxMinutes"
                          value={pacesClub.paceMaxMinutes}
                          onChange={handlePacesChange}
                          min="3"
                          max="10"
                          placeholder="Min"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        />
                        <span className="self-center">:</span>
                        <input
                          type="number"
                          name="paceMaxSecondes"
                          value={pacesClub.paceMaxSecondes}
                          onChange={handlePacesChange}
                          min="0"
                          max="59"
                          placeholder="Sec"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        />
                        <span className="self-center text-gray-600">/km</span>
                      </div>
                    </div>
                  </div>

                  {pacesClub.paceMinMinutes && pacesClub.paceMaxMinutes && (
                    <div className="text-center p-3 bg-white rounded-lg border-2 border-indigo-200">
                      <p className="text-sm text-gray-600">Plage de paces du club :</p>
                      <p className="text-xl font-bold text-indigo-600">
                        {formatPace(pacesClub.paceMinMinutes, pacesClub.paceMinSecondes)} - {formatPace(pacesClub.paceMaxMinutes, pacesClub.paceMaxSecondes)} /km
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Planification des séances */}
            <div className="border-t pt-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-white">Séances hebdomadaires</h3>
                <button
                  type="button"
                  onClick={ajouterSeance}
                  className="flex items-center space-x-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
                >
                  <Plus size={20} />
                  <span>Ajouter une séance</span>
                </button>
              </div>

              {seances.length === 0 ? (
                <p className="text-gray-500 text-center py-8 bg-gray-50 rounded-lg">
                  Aucune séance planifiée. Cliquez sur "Ajouter une séance" pour commencer.
                </p>
              ) : (
                <div className="space-y-4">
                  {seances.map((seance, index) => (
                    <div key={index} className="p-4 bg-gray-50 rounded-lg border-2 border-gray-200">
                      <div className="flex justify-between items-start mb-3">
                        <h4 className="font-semibold text-gray-800">Séance {index + 1}</h4>
                        <button
                          type="button"
                          onClick={() => supprimerSeance(index)}
                          className="text-red-600 hover:text-red-700"
                        >
                          <Trash2 size={20} />
                        </button>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Jour</label>
                          <select
                            value={seance.jour}
                            onChange={(e) => modifierSeance(index, 'jour', e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                          >
                            <option value="Lundi">Lundi</option>
                            <option value="Mardi">Mardi</option>
                            <option value="Mercredi">Mercredi</option>
                            <option value="Jeudi">Jeudi</option>
                            <option value="Vendredi">Vendredi</option>
                            <option value="Samedi">Samedi</option>
                            <option value="Dimanche">Dimanche</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Heure</label>
                          <input
                            type="time"
                            value={seance.heure}
                            onChange={(e) => modifierSeance(index, 'heure', e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                          />
                        </div>

                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Type</label>
                          <select
                            value={seance.typeSeance}
                            onChange={(e) => modifierSeance(index, 'typeSeance', e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                          >
                            <option value="Endurance Fondamentale">Endurance Fondamentale</option>
                            <option value="Récupération">Récupération</option>
                            <option value="Seuil/Tempo">Seuil/Tempo</option>
                            <option value="Fractionné Court">Fractionné Court</option>
                            <option value="Fractionné Long">Fractionné Long</option>
                            <option value="Sortie Longue">Sortie Longue</option>
                            <option value="Autre">Autre</option>
                          </select>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Distance (optionnel)</label>
                          <input
                            type="text"
                            value={seance.distance}
                            onChange={(e) => modifierSeance(index, 'distance', e.target.value)}
                            placeholder="Ex: 10 km, 5x1000m, etc."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                          />
                        </div>

                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Pace cible (optionnel)</label>
                          <div className="flex space-x-2">
                            <input
                              type="number"
                              value={seance.paceMinMinutes}
                              onChange={(e) => modifierSeance(index, 'paceMinMinutes', e.target.value)}
                              placeholder="Min"
                              className="w-16 px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                            />
                            <span className="self-center">:</span>
                            <input
                              type="number"
                              value={seance.paceMinSecondes}
                              onChange={(e) => modifierSeance(index, 'paceMinSecondes', e.target.value)}
                              placeholder="Sec"
                              className="w-16 px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                            />
                            <span className="self-center text-gray-600">/km</span>
                          </div>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm text-gray-600 mb-1">Description (optionnel)</label>
                        <textarea
                          value={seance.description}
                          onChange={(e) => modifierSeance(index, 'description', e.target.value)}
                          placeholder="Détails de la séance..."
                          rows="2"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Lieu de rendez-vous
                        </label>
                        <input
                          type="text"
                          placeholder="ex: Parc Maisonneuve, entrée principale"
                          value={seance.lieu}
                          onChange={(e) => modifierSeance(index, 'lieu', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              onClick={handleSubmit}
              className="w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition font-semibold text-lg"
            >
              Créer le groupe
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default CreateClub;